<script lang="ts">
  import { ContainerDescription } from "@retailer/svelte/ListDetail/View/Utils/ProductContainerDetail";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import { getProductForDescription } from "@retailer/svelte/Shared/OrderHelpers";

  export let product;
</script>

<li>
  <p>
    {product.product_line.name}; {ContainerDescription(
      getProductForDescription(product),
    )}{#if product.case_quantity}; {pluralize(
        "case",
        product.case_quantity,
        true,
      )}{#if product.unit_quantity},
      {/if}{/if}{#if product.unit_quantity}{#if !product.case_quantity};
      {/if}{pluralize(product.product.container_type, product.unit_quantity, true)}{/if}
  </p>
  <ul class="fizz-unordered-list">
    {#if product.deal_notes}
      <li><p>Deal note: {product.deal_notes}</p></li>
    {/if}
    {#if product.permanent_deal_notes && product.permanent_deal_notes.notes && product.permanent_deal_notes.notes !== product.deal_notes}
      <li><p>Deal note: {product.permanent_deal_notes.notes}</p></li>
    {/if}
  </ul>
</li>
